export const Constants = {
  token: 'Token',
  type: 'Type',
  currentUser: 'currentUser',
  secret:'secret'
};
